import React from 'react'
import { getMasqueradeToken } from 'helpers/auth'
import { useAuth } from 'hooks/auth'

const MasqueradeWarning = () => {
  const { user } = useAuth()
  if (!getMasqueradeToken()) {
    return null
  }

  return (
    <div className="absolute bg-red text-on-solid p-4 rounded left-[50%] bottom-[10%] z-[99] [--tw-translate-x:-50%] translate-y-full">
      Logged in as {user?.email}. Proceed with caution!
    </div>
  )
}

export default MasqueradeWarning
